var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fileadministrationTop"},[_c('FromComm',{attrs:{"FromArr":_vm.FromArr}}),_c('div',{staticClass:"CommonBtngroup"},[_c('CommonBtngroup',{attrs:{"qhide":false},on:{"select":_vm.select,"reset":_vm.reset}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }